// Emoji seçicisine eklenen MARKA simgeleri.
//
// Neden gerekli: Unicode'da Instagram, WhatsApp, Gmail, TikTok logosu YOK. Anahtar serbest emojiye
// çevrilince marka bağlantılarını temsil edecek hiçbir simge kalmamıştı — 📷 Instagram demek
// değil. emoji-picker-react bunu `customEmojis` ile çözüyor: simgeler picker'ın içinde kendi
// kategorisinde, aranabilir şekilde duruyor.
//
// Görseller `public/brands/` altında ve MENÜDE DE AYNI DOSYALAR var (menu/public/brands). İki
// uygulama aynı görüntüyü basmak zorunda: panelde seçilen simge menüde bire bir görünmeli. Yeni
// marka = iki klasöre aynı SVG + buraya bir satır.
//
// id `brand:` ile başlıyor: menü tarafı anahtarın emoji mi marka mı olduğunu buradan anlıyor
// (emoji hiçbir zaman bu önekle başlamaz), ve `<img src="/brands/<ad>.svg">` adresini id'den
// türetiyor.
export const BRAND_PREFIX = "brand:";

// `names` picker'ın arama kutusunu besliyor — hem Türkçe hem İngilizce yazınca bulunsun.
const BRANDS = [
  { name: "instagram", names: ["instagram", "insta"] },
  { name: "whatsapp", names: ["whatsapp", "wp", "watsap"] },
  { name: "gmail", names: ["gmail", "mail", "eposta", "e-posta", "email"] },
  { name: "phone", names: ["telefon", "phone", "ara", "call"] },
  {
    name: "maps",
    names: ["maps", "harita", "konum", "yol tarifi", "google maps"],
  },
  { name: "website", names: ["website", "web sitesi", "site", "internet"] },
  { name: "facebook", names: ["facebook", "fb"] },
  { name: "x", names: ["x", "twitter"] },
  { name: "tiktok", names: ["tiktok", "tik tok"] },
  { name: "youtube", names: ["youtube", "yt", "video"] },
  { name: "telegram", names: ["telegram", "tg"] },
];

export const brandUrl = (name) => `/brands/${name}.svg`;

export const BRAND_EMOJIS = BRANDS.map((brand) => ({
  id: `${BRAND_PREFIX}${brand.name}`,
  names: brand.names,
  imgUrl: brandUrl(brand.name),
}));

// Anahtar bir marka simgesi mi? Değilse emoji ya da yüklenmiş bir simgedir.
export const brandName = (icon) =>
  icon?.startsWith(BRAND_PREFIX) ? icon.slice(BRAND_PREFIX.length) : null;

// Kullanıcının kendi yüklediği simge mi? O zaman anahtar doğrudan R2 adresi (bkz. api tenant
// /link-icon). Üç biçim aynı alanda yaşıyor ve ayrım tamamen önekten: `brand:` → marka, `http` →
// yüklenmiş, geri kalan → emoji.
export const isUploadedIcon = (icon) => /^https?:\/\//i.test(icon ?? "");
